import { atom } from "recoil";

export const inspectClipboardToastStatus = atom<boolean>({
  key: "inspectClipboardToastStatus",
  default: false,
});

export const inspectResultClipboardToastStatus = atom<boolean>({
  key: "inspectResultClipboardToastStatus",
  default: false,
});
